import { useState } from 'react';

const useCommon = () => {
    const [deviceTypes, setDeviceTypes] = useState<any>();
    const [systemLogTypes, setSystemLogTypes] = useState();
    // const [products,setProducts] = useState();
    return {
        deviceTypes,
        setDeviceTypes,
        systemLogTypes,
        setSystemLogTypes
    };
};

export default useCommon;
